import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

function InputField({ fieldState, helperText, label = '', params, placeholder = '', scrollableTags }) {
  const { slotProps = {}, ...restParams } = params;
  const { htmlInput = {}, input = {}, inputLabel = {}, ...restSlotProps } = slotProps;
  const { startAdornment, ...restInputSlotProps } = input;

  return (
    <TextField
      {...restParams}
      error={!!fieldState?.error}
      helperText={fieldState?.error?.message || helperText}
      label={label}
      placeholder={placeholder}
      slotProps={{
        ...restSlotProps,
        htmlInput: {
          ...htmlInput,
          autoComplete: 'off',
        },
        input: {
          ...restInputSlotProps,
          startAdornment: scrollableTags
            ? startAdornment && (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    maxHeight: 116,
                    overflowY: 'auto',
                    width: '100%',
                  }}
                >
                  {startAdornment}
                </div>
              )
            : startAdornment,
        },
        inputLabel: { ...inputLabel, shrink: true },
      }}
    />
  );
}

InputField.propTypes = {
  fieldState: PropTypes.shape({
    error: PropTypes.shape({
      message: PropTypes.string,
    }),
  }).isRequired,
  helperText: PropTypes.string.isRequired,
  label: PropTypes.string,
  params: PropTypes.shape({
    slotProps: PropTypes.shape({
      htmlInput: PropTypes.object,
      input: PropTypes.shape({
        startAdornment: PropTypes.node,
      }),
      inputLabel: PropTypes.object,
    }),
  }).isRequired,
  placeholder: PropTypes.string,
  scrollableTags: PropTypes.bool,
};

export default InputField;
